import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import CheckoutButton from "./CheckoutButton";

const STACK = [
  { label: "Ebook principal", value: "USD 27" },
  { label: "Planificador semanal", value: "USD 19" },
  { label: "Lista de compras", value: "USD 12" },
  { label: "Guía de porciones por edad", value: "USD 15" },
  { label: "30 snacks saludables", value: "USD 14" },
];

export default function MidCTA() {
  return (
    <section
      data-testid="mid-cta-section"
      className="bg-[#FBF4E7] py-16 md:py-24"
    >
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative bg-gradient-to-br from-[#849983] to-[#6F856E] rounded-[2.5rem] p-8 md:p-12 lg:p-14 text-center overflow-hidden shadow-[0_30px_80px_rgba(132,153,131,0.35)]"
        >
          <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
          <div className="relative">
            <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-white/70">
              Acceso completo con todos los bonos
            </p>
            <h2 className="mt-3 font-serif-display text-3xl md:text-5xl leading-tight text-white">
              Empieza a cocinar con <em className="italic">calma y amor</em> hoy mismo.
            </h2>

            {/* Value stack */}
            <div className="mt-9 bg-white/10 backdrop-blur-sm rounded-3xl p-6 md:p-8 max-w-xl mx-auto text-left border border-white/15">
              <ul className="space-y-2.5">
                {STACK.map((s) => (
                  <li
                    key={s.label}
                    data-testid={`stack-${s.label.replace(/\s+/g, "-").toLowerCase()}`}
                    className="flex items-center justify-between gap-4 text-white/95 text-sm md:text-[15px]"
                  >
                    <span className="flex items-center gap-2.5 min-w-0">
                      <Check className="h-4 w-4 text-[#C8A892] shrink-0" strokeWidth={2.4} />
                      <span className="truncate">{s.label}</span>
                    </span>
                    <span className="text-white/70 shrink-0">{s.value}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-5 pt-4 border-t border-white/15 flex items-center justify-between gap-3">
                <span className="text-[10px] md:text-[11px] tracking-[0.18em] uppercase font-semibold text-white/70 leading-tight">
                  Valor real del ebook y los bonos
                </span>
                <span className="font-serif-display text-xl text-white shrink-0">
                  <span className="line-through text-white/50 mr-2">USD 87</span>
                </span>
              </div>
            </div>

            <p className="mt-7 text-white/85">
              <span className="text-[11px] tracking-[0.22em] uppercase font-semibold text-white/70 block mb-2">
                Hoy
              </span>
              <span className="font-serif-display text-5xl md:text-6xl text-white block leading-none">
                USD 9.90
              </span>
              <span className="text-xs text-white/65 block mt-2">
                Acceso inmediato · Todos los bonos incluidos
              </span>
            </p>

            <div className="mt-8 flex justify-center">
              <CheckoutButton
                label="SÍ, QUIERO ALIMENTAR MEJOR A MI HIJO"
                testId="mid-cta-button"
                size="xl"
                variant="dark"
                fullWidthMobile
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
